import { c as _c } from "react/compiler-runtime";
/** biome-ignore-all lint/a11y/noStaticElementInteractions: <explanation> */
/** biome-ignore-all lint/a11y/useKeyWithClickEvents: <explanation> */

import { cn } from "@/lib/utils";
export type CarouselBulletsProps<T> = {
  array: Array<T>;
  showCount?: number;
  activeIndex: number;
  setActiveIndex: (index: number) => void;
};
export const CarouselBullets = t0 => {
  const $ = _c(20);
  let activeIndex;
  let array;
  let className;
  let props;
  let setActiveIndex;
  let t1;
  if ($[0] !== t0) {
    ({
      array,
      activeIndex,
      setActiveIndex,
      showCount: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = activeIndex;
    $[2] = array;
    $[3] = className;
    $[4] = props;
    $[5] = setActiveIndex;
    $[6] = t1;
  } else {
    activeIndex = $[1];
    array = $[2];
    className = $[3];
    props = $[4];
    setActiveIndex = $[5];
    t1 = $[6];
  }
  t1 === undefined ? 3 : t1;
  let t2;
  if ($[7] !== className) {
    t2 = cn("flex items-center justify-center gap-2", className);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== activeIndex || $[10] !== array || $[11] !== setActiveIndex) {
    let t4;
    if ($[13] !== activeIndex || $[14] !== setActiveIndex) {
      t4 = (_, index) => {
        const isActive = index === activeIndex;
        return <div key={`bullet-${index}`} className={cn("size-1.25 cursor-pointer rounded-full transition-transform duration-200 ease-out", isActive ? "bg-not-active opacity-100" : "bg-active opacity-20 hover:opacity-70")} onClick={e => {
          e.stopPropagation();
          setActiveIndex(index);
        }} />;
      };
      $[13] = activeIndex;
      $[14] = setActiveIndex;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    t3 = array.map(t4);
    $[9] = activeIndex;
    $[10] = array;
    $[11] = setActiveIndex;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[16] !== props || $[17] !== t2 || $[18] !== t3) {
    t4 = <div className={t2} {...props}>{t3}</div>;
    $[16] = props;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
};